<template>
  <v-navigation-drawer
    v-model="drawerController"
    fixed
    clipped
    temporary
    dark
    width="260"
    class="navbar-drawer--dark mini-navbar-drawer elevation-5"
  >
    <StSystemNavigationDrawerList
      max-width="244px"
      :subtitle="subtitle"
      :previous-label="previousLabel"
      :previous-product="previousProduct"
      :items-obj="items"
      :item-active="activeUrl"
      @navigate="$emit('navigate', $event)"
    />
  </v-navigation-drawer>
</template>

<script>
import StSystemNavigationDrawerList from './StSystemNavigationDrawerList';
export default {
  name: 'StSystemNavigationDrawer',
  components: {
    StSystemNavigationDrawerList
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    activeUrl: {
      type: String,
      required: true
    },
    drawer: {
      type: Boolean,
      default: false
    },
    subtitle: {
      type: String,
      default: ''
    },
    previousLabel: {
      type: String,
      default: ''
    },
    previousProduct: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      drawerController: this.drawer
    };
  },
  watch: {
    drawer: 'onDrawerChanged'
  },
  methods: {
    onDrawerChanged(value) {
      this.drawerController = value;
      this.$emit('changed', this.drawerController);
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar-drawer {
  &--dark {
    background-color: var(--gray-100) !important;
    max-height: calc(100vh - 50px);
    top: 50px !important;

    span {
      color: #98999d;
    }
  }
}
</style>
